module.exports = "/_next/static/images/5b2123bcd970080ea96f38c98fd4dca5-roxinho-scene-card-with-phone-md@1x.jpg";